// Autogenerated by Hanako
import { Header } from '../../views/twig/components/Header';
import { Alert } from '../../views/ts/components/Alert';
import { BtnLoading } from '../../views/ts/components/BtnLoading';
import { Collapse } from '../../views/ts/components/Collapse';
import { Carousel } from '../../views/ts/components/Carousel';
import { Dropdown } from '../../views/ts/components/Dropdown';
import { FormFields } from '../../views/ts/components/FormFields';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Share } from '../../views/ts/components/Share';
import { Site } from '../../views/ts/components/Site';
import { MouseCursor } from '../../views/twig/components/MouseCursor';
import { Form } from '../../views/twig/pages/singles/assessment';
import { Dashboard } from '../../views/twig/pages/templates/dashboard';
import { Synthesis } from '../../views/twig/pages/templates/synthesis';
import { TextImage } from '../../views/twig/modules/text_image/';
import { Assessment } from '../../views/twig/modules/presentation/';
import { Tooltips } from '../../views/ts/components/Tooltips';
(new Header()).init();
(new Alert()).init();
(new BtnLoading()).init();
(new Collapse()).init();
(new Dropdown()).init();
(new FormFields()).init();
(new LazyLoader()).init();
(new Share()).init();
(new Site()).init();
(new MouseCursor()).init();
(new Form()).init();
(new Dashboard()).init();
(new Synthesis()).init();
(new TextImage()).init();
(new Carousel()).init();
(new Tooltips()).init();
(new Assessment()).init();
